module.exports = __webpack_public_path__ + "img/ab-testing-dark.73592385.svg";